import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Link,
  Divider,
} from '@mui/material'
import ViewIcon from '@mui/icons-material/Visibility'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import PeopleIcon from '@mui/icons-material/People'
import PhoneIcon from '@mui/icons-material/Phone'

export default function MobileFamilyCard({ family, onDelete, onView, onEdit }) {
  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    // Remove all non-numeric characters
    const cleaned = phone.replace(/\D/g, '');
    // Format the number
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phone;
  };

  return (
    <Card sx={{ mb: 2, borderRadius: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600 }}>
            {family.family_name}
          </Typography>
          <Box>
            <IconButton
              size="small"
              onClick={() => onView(family)}
              color="primary"
              sx={{ mr: 1 }}
            >
              <ViewIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => onEdit?.(family)}
              sx={{ mr: 1 }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => onDelete(family.id)}
              color="error"
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PeopleIcon color="action" fontSize="small" />
          <Typography variant="body2" color="text.secondary">
            {family.contacts?.length || 0} members
          </Typography>
        </Box>

        {family.phone && (
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <PhoneIcon sx={{ mr: 1, fontSize: 20, color: 'text.secondary' }} />
            <Link 
              href={`tel:${family.phone}`}
              sx={{ 
                textDecoration: 'none',
                color: 'primary.main',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              {formatPhoneNumber(family.phone)}
            </Link>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
